import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  ListGroup,
  Form,
  FloatingLabel,
  OverlayTrigger,
  Tooltip,
  Button,
  Card,
  Container,
  Dropdown,
} from "react-bootstrap";
import { Image } from "cloudinary-react";
import Message from "../components/message";
import {
  addToCart,
  updateCart,
  removeItemInCart,
  addToCartDB,
  updateCartToDB,
  removeCartItemInDB,
} from "../actions/cart";
import Loader from "../components/loader";
import { ORDER_CREATE_RESET } from "../actions/types";

const CartScreen = ({ match, location, history }) => {
  const productId = match.params.id;
  const params = location.search ? location.search.split("&") : "";

  const qty = params
    ? params[0].split("=")[1]
      ? Number(params[0].split("=")[1])
      : 1
    : "";
  const capacity = params ? params[1].split("=")[1] : "";
  const color = params ? params[2].split("=")[1] : "";

  const dispatch = useDispatch();

  const cart = useSelector((state) => state.cart);
  const { cartItems, cartLoading, cartError } = cart;

  const userAuth = useSelector((state) => state.userAuth);
  const { userInfo } = userAuth;

  useEffect(() => {
    if (productId) {
      if (userInfo) {
        // Get the cart in database and add the onces from local storage
        // signed user - which is admin
        dispatch(addToCartDB(productId, qty, capacity, color));
      } else {
        // site visitor
        dispatch(addToCart(productId, qty, capacity, color));
      }
    }
  }, [dispatch, history, productId, qty, capacity, color, userInfo]);

  const removeFromCartHandler = (productId, capacity, color) => {
    if (userInfo) {
      // signed user - which is admin
      dispatch(removeCartItemInDB(productId, capacity, color));
    } else {
      // site visitor
      dispatch(removeItemInCart(productId, capacity, color));
    }
  };

  const checkoutHandler = () => {
    // to make that the order state is reset
    dispatch({ type: ORDER_CREATE_RESET });
    // history.push("/login?redirect=shipping");
    //redirect to shipping for admin and visitors
    history.push("/shipping");
  };

  const quantityOnChangeHandler = (e, item, index) => {
    if (userInfo) {
      dispatch(
        updateCartToDB(
          item.productId,
          Number(e.target.value),
          item.capacity,
          item.color
        )
      );
    } else {
      dispatch(
        updateCart(
          item.productId,
          Number(e.target.value),
          item.capacity,
          item.color,
          index,
          item.description
        )
      );
    }
  };

  const loaderStyle = {
    position: "absolute",
    top: "40%",
    left: "40%",
    zIndex: "4",
  };

  return (
    <Container>
      <Row>
        <Col md={8}>
          <h1>SHOPPING CART</h1>
          {cartError && <Message variant="danger">{cartError}</Message>}
          {cartLoading && (
            <div style={loaderStyle}>
              <Loader />
            </div>
          )}
          {cartItems.length === 0 ? (
            <Message>
              Your cart is empty <Link to="/">Go Back</Link>
            </Message>
          ) : (
            <ListGroup
              variant="flush"
              style={
                cartLoading ? { opacity: "0.4", backgroundColor: "grey" } : null
              }
            >
              {cartItems &&
                cartItems.map((item, index) => {
                  return (
                    <ListGroup.Item key={`${item.productId}cart${index}`}>
                      <Row
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <Col
                          md={2}
                          style={{
                            width: "120px",
                          }}
                        >
                          <Image
                            className="img-thumbnail"
                            cloudName={"dljielsye"}
                            publicId={
                              item.image && item.image.length > 0
                                ? item.image[0]
                                : ""
                            }
                            // width={100}
                            style={{
                              width: "100%",
                              height: "120px",
                              objectFit: "contain",
                              display: "flex",
                              justifyContent: "center",
                            }}
                            alt={item.name}
                            fluid
                            rounded
                          />
                        </Col>
                        <Col md={3}>
                          <Link
                            to={`/product/${item.productId}`}
                            style={{
                              textDecoration: "none",
                              color: "#0d6efd",
                            }}
                          >
                            <strong>{item.name}</strong>
                          </Link>
                        </Col>
                        <Col md={2}>
                          <h2 style={{ padding: 0 }}>Capacity:</h2>{" "}
                          {item.capacity} GB
                        </Col>
                        <Col md={2}>
                          <h2 style={{ padding: 0 }}>Price:</h2>$
                          {item.price - item.discount}
                        </Col>
                        {/* <Col md={2}>
                          <FloatingLabel label="Quantity">
                            <Form.Select
                              value={item.qty}
                              onChange={(e) =>
                                quantityOnChangeHandler(e, item, index)
                              }
                            >
                              {[...Array(item.totalSize).keys()].map((x) => (
                                <option key={x + 1} value={x + 1}>
                                  {x + 1}
                                </option>
                              ))}
                            </Form.Select>
                          </FloatingLabel>
                        </Col> */}

                        <Col
                          md={2}
                          style={{ position: "relative", top: "7px" }}
                        >
                          <h2
                            style={{
                              padding: 0,
                              marginBottom: "7px",
                            }}
                          >
                            Quantity:
                          </h2>{" "}
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="outline-secondary"
                              className="w-100"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              {item.qty}
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                              style={{
                                maxHeight: "200px",
                                overflowY: "auto",
                              }}
                            >
                              {[...Array(item.totalSize).keys()].map((x) => (
                                <Dropdown.Item
                                  key={x + 1}
                                  onClick={() =>
                                    quantityOnChangeHandler(
                                      { target: { value: x + 1 } },
                                      item,
                                      index
                                    )
                                  }
                                >
                                  {x + 1}
                                </Dropdown.Item>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        </Col>

                        {/*  */}

                        <Col md={1}>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="button-tooltip">
                                {"remove from cart"}
                              </Tooltip>
                            }
                          >
                            <Button
                              type="button"
                              variant="light"
                              onClick={() =>
                                removeFromCartHandler(
                                  item.productId,
                                  item.capacity,
                                  item.color
                                )
                              }
                            >
                              <i className="fas fa-trash" />
                            </Button>
                          </OverlayTrigger>
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  );
                })}
            </ListGroup>
          )}
        </Col>
        <Col md={4}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <h2 style={{ textAlign: "center" }}>CHECKOUT SUMMARY</h2>
                <Row>
                  <Col md={8}>
                    SUBTOTAL (
                    {cartItems.reduce((acc, item) => acc + item.qty, 0)}) ITEMS
                  </Col>
                  <Col md={4} style={{ textAlign: "right" }}>
                    $
                    {cartItems
                      .reduce(
                        (acc, item) =>
                          acc + item.qty * (item.price - item.discount),
                        0
                      )
                      .toFixed(2)}
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>TOTAL</Col>
                  <Col md={6} style={{ textAlign: "right" }}>
                    $
                    {cartItems
                      .reduce(
                        (acc, item) =>
                          acc + item.qty * (item.price - item.discount),
                        0
                      )
                      .toFixed(2)}
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <span className="d-grid gap-2">
                  <Button
                    type="button"
                    disabled={cartItems.length === 0 || cartLoading}
                    onClick={checkoutHandler}
                    style={{
                      backgroundColor: "black",
                      color: "white",
                      border: "1px solid black",
                      paddingLeft: "2rem",
                      paddingRight: "2rem",
                      textAlign: "center",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#514f4f";
                      e.target.style.color = "white";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "black";
                      e.target.style.color = "white";
                    }}
                  >
                    CHECKOUT NOW
                  </Button>
                </span>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default CartScreen;
